import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import CommunityDrawer from './CommunityDrawer';

/**
 * Global wrapper around CommunityDrawer mounted once in App.js.
 *
 * Triggers:
 *  - Mobile bottom nav button (sets state directly when same file used to be tightly coupled).
 *  - Desktop Navbar link via `window.dispatchEvent('open-community-drawer')`.
 *
 * Hidden on role-internal panels — those have their own sidebars + a different
 * audience that doesn't need the public Comunidad list.
 */
const GlobalCommunityDrawer = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onOpen = () => setOpen(true);
    window.addEventListener('open-community-drawer', onOpen);
    return () => window.removeEventListener('open-community-drawer', onOpen);
  }, []);

  // Close when route changes (so clicking an item that navigates closes the drawer).
  useEffect(() => { setOpen(false); }, [location.pathname]);

  // Hide on role-internal panels
  if (
    location.pathname.startsWith('/admin') ||
    location.pathname.startsWith('/producer') ||
    location.pathname.startsWith('/partner') ||
    location.pathname.startsWith('/prensa') ||
    location.pathname.startsWith('/validador') ||
    location.pathname.startsWith('/validator')
  ) {
    return null;
  }

  return <CommunityDrawer open={open} onClose={() => setOpen(false)} />;
};

export default GlobalCommunityDrawer;
